import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=db2aa078&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=db2aa078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2aa078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db2aa078')) {
      api.createRecord('db2aa078', component.options)
    } else {
      api.reload('db2aa078', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=db2aa078&scoped=true&", function () {
      api.rerender('db2aa078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cOHALZWSULwj/JS/comp/Voucher.vue"
export default component.exports